import { createContext, useContext, useState, useEffect } from "react";

const dict = {
  fr: {
    nav: { home: "Accueil", discover: "Découvrir", map: "Carte", about: "À propos", why: "Pourquoi", login: "Connexion", register: "Inscrire mon commerce", dashboard: "Tableau de bord", logout: "Déconnexion" },
    hero: {
      tagline: "Découvrez · Dégustez · Connectez",
      title1: "Les meilleurs cafés du",
      title2: "Québec.",
      sub: "CAFÉ-SPOT — la plateforme qui vous fait découvrir les cafés, boulangeries et pâtisseries artisanales partout au Québec et au Canada.",
      cta1: "Découvrir les commerces",
      cta2: "Inscrire mon commerce",
    },
    sections: {
      experienceLabel: "Plateforme",
      experienceTitle: "Découvrez les artisans qui font la différence.",
      featuresLabel: "Fonctionnalités",
      featuresTitle: "Tout pour explorer · réserver · se rendre sur place.",
      galleryLabel: "Inspirations",
      galleryTitle: "L'art du café, l'art de recevoir.",
      ctaTitle: "Vous êtes propriétaire d'un café, d'une boulangerie ou d'une pâtisserie ?",
      ctaSub: "Gagnez en visibilité auprès de milliers de visiteurs au Québec. Essai 14 jours · 6 jours de grâce sur les paiements.",
      ctaBtn: "Inscrire mon commerce",
      empty: "Découvrez bientôt les meilleurs cafés et boulangeries du Québec.",
    },
    feature: [
      { t: "Découverte locale", d: "Trouvez les artisans du café près de chez vous, partout au Québec." },
      { t: "Menus & photos", d: "Consultez les cartes, les ambiances et les services avant de vous déplacer." },
      { t: "Réservation directe", d: "Réservez une table en quelques clics, sans intermédiaire." },
      { t: "Itinéraire & contact", d: "Appel direct, GPS, horaires — tout pour vous rendre sur place." },
      { t: "Carte interactive", d: "Explorez les commerces par ville, région et catégorie." },
      { t: "100 % Québec", d: "Une plateforme québécoise, pour soutenir les artisans d'ici." },
    ],
    auth: {
      welcomeBack: "Bon retour", createAccount: "Créer votre compte",
      email: "Adresse courriel", password: "Mot de passe", name: "Nom complet", cafeName: "Nom du commerce",
      asCustomer: "Visiteur", asCafeOwner: "Propriétaire",
      submit: "Continuer", noAccount: "Pas encore de compte ?", hasAccount: "Déjà inscrit ?",
      signIn: "Se connecter", signUp: "S'inscrire",
    },
    dash: {
      overview: "Vue d'ensemble", menu: "Menu", reservations: "Réservations", settings: "Mon commerce",
      totalReservations: "Réservations", pending: "En attente", confirmed: "Confirmées", productsCount: "Items au menu",
      reservations14d: "Réservations · 14 derniers jours", upcoming: "Réservations à venir",
      addProduct: "Ajouter un item", noProducts: "Aucun item dans votre menu",
      noReservations: "Aucune réservation pour le moment",
      price: "Prix", category: "Catégorie", available: "Disponible", actions: "Actions",
      edit: "Modifier", delete: "Supprimer", save: "Enregistrer", cancel: "Annuler",
      status: "Statut", customer: "Client", date: "Date", time: "Heure", party: "Personnes", phone: "Téléphone",
    },
    super: {
      title: "Console Super Admin", subtitle: "Vue globale de la plateforme",
      totalCafes: "Commerces", activeCafes: "Actifs", trialCafes: "Essai", sponsoredCafes: "Sponsorisés",
      totalUsers: "Utilisateurs", totalReservations: "Réservations totales",
      manageCafes: "Gestion des commerces",
    },
    cafe: {
      hours: "Horaires", services: "Services", contact: "Contact", address: "Adresse",
      call: "Appeler", directions: "Itinéraire",
      menu: "Menu", reserve: "Réserver une table",
      reserveTitle: "Réserver une table", yourName: "Votre nom", yourPhone: "Téléphone", yourEmail: "Courriel (optionnel)",
      partySize: "Nombre de personnes", date: "Date", time: "Heure", notes: "Notes (optionnel)",
      sendRequest: "Envoyer la demande", success: "Demande envoyée — le commerce vous contactera pour confirmer.",
      closed: "Fermé", notAcceptingReservations: "Ce commerce n'accepte pas de réservations en ligne pour le moment.",
      emptyMenu: "Le menu sera publié prochainement.",
    },
    discover: {
      title: "Découvrir", subtitle: "Cafés · Boulangeries · Pâtisseries artisanales",
      filterCategory: "Catégorie", filterCity: "Ville", all: "Tous",
      empty: "Les commerces apparaîtront ici après leur inscription.",
    },
    days: { mon: "Lun", tue: "Mar", wed: "Mer", thu: "Jeu", fri: "Ven", sat: "Sam", sun: "Dim" },
    footer: { tagline: "CAFÉ-SPOT — La plateforme de découverte des commerces artisanaux du Québec.", contact: "Contact", legal: "Mentions légales", platform: "Plateforme", region: "Québec · Canada" },
  },
  en: {
    nav: { home: "Home", discover: "Discover", map: "Map", about: "About", why: "Why", login: "Sign in", register: "List my business", dashboard: "Dashboard", logout: "Sign out" },
    hero: {
      tagline: "Discover · Taste · Connect",
      title1: "The finest cafés in",
      title2: "Quebec.",
      sub: "CAFÉ-SPOT — the platform that helps you discover the cafés, bakeries, and artisan pastry shops across Quebec and Canada.",
      cta1: "Discover businesses",
      cta2: "List my business",
    },
    sections: {
      experienceLabel: "Platform",
      experienceTitle: "Discover the artisans who make the difference.",
      featuresLabel: "Features",
      featuresTitle: "Everything to explore · book · visit.",
      galleryLabel: "Inspirations",
      galleryTitle: "The art of coffee, the art of hospitality.",
      ctaTitle: "Own a café, bakery, or pastry shop?",
      ctaSub: "Gain visibility with thousands of Quebec visitors. 14-day trial · 6-day payment grace period.",
      ctaBtn: "List my business",
      empty: "Soon you'll discover Quebec's finest cafés and bakeries.",
    },
    feature: [
      { t: "Local discovery", d: "Find coffee artisans near you, anywhere in Quebec." },
      { t: "Menus & photos", d: "Check menus, atmosphere, and services before you go." },
      { t: "Direct reservation", d: "Book a table in a few clicks, no middleman." },
      { t: "Directions & contact", d: "Direct call, GPS, hours — everything to visit." },
      { t: "Interactive map", d: "Explore businesses by city, region, and category." },
      { t: "100% Quebec", d: "A Quebec platform supporting local artisans." },
    ],
    auth: {
      welcomeBack: "Welcome back", createAccount: "Create your account",
      email: "Email", password: "Password", name: "Full name", cafeName: "Business name",
      asCustomer: "Visitor", asCafeOwner: "Business owner",
      submit: "Continue", noAccount: "Don't have an account?", hasAccount: "Already have one?",
      signIn: "Sign in", signUp: "Sign up",
    },
    dash: {
      overview: "Overview", menu: "Menu", reservations: "Reservations", settings: "My business",
      totalReservations: "Reservations", pending: "Pending", confirmed: "Confirmed", productsCount: "Menu items",
      reservations14d: "Reservations · last 14 days", upcoming: "Upcoming reservations",
      addProduct: "Add menu item", noProducts: "No menu items yet",
      noReservations: "No reservations yet",
      price: "Price", category: "Category", available: "Available", actions: "Actions",
      edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel",
      status: "Status", customer: "Customer", date: "Date", time: "Time", party: "Party", phone: "Phone",
    },
    super: {
      title: "Super Admin Console", subtitle: "Platform overview",
      totalCafes: "Businesses", activeCafes: "Active", trialCafes: "Trial", sponsoredCafes: "Sponsored",
      totalUsers: "Users", totalReservations: "Total reservations",
      manageCafes: "Manage businesses",
    },
    cafe: {
      hours: "Hours", services: "Services", contact: "Contact", address: "Address",
      call: "Call", directions: "Directions",
      menu: "Menu", reserve: "Reserve a table",
      reserveTitle: "Reserve a table", yourName: "Your name", yourPhone: "Phone", yourEmail: "Email (optional)",
      partySize: "Number of guests", date: "Date", time: "Time", notes: "Notes (optional)",
      sendRequest: "Send request", success: "Request sent — the business will contact you to confirm.",
      closed: "Closed", notAcceptingReservations: "This business doesn't accept online reservations at the moment.",
      emptyMenu: "Menu coming soon.",
    },
    discover: {
      title: "Discover", subtitle: "Cafés · Bakeries · Artisan pastry",
      filterCategory: "Category", filterCity: "City", all: "All",
      empty: "Businesses will appear here once they register.",
    },
    days: { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun" },
    footer: { tagline: "CAFÉ-SPOT — Quebec's artisan discovery platform.", contact: "Contact", legal: "Legal", platform: "Platform", region: "Quebec · Canada" },
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "fr");
  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);
  const t = (path) => {
    const parts = path.split(".");
    let cur = dict[lang];
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  };
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}
export const useI18n = () => useContext(I18nCtx);
